import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useGeoBrowseThresholds } from '../hooks/useGeoBrowseThresholds';

type GeoBrowseContextValue = ReturnType<typeof useGeoBrowseThresholds>;

const GeoBrowseContext = createContext<GeoBrowseContextValue | null>(null);

export function GeoBrowseProvider({ children }: { children: ReactNode }) {
  const value = useGeoBrowseThresholds();
  const memo = useMemo(() => value, [value]);
  return <GeoBrowseContext.Provider value={memo}>{children}</GeoBrowseContext.Provider>;
}

export function useGeoBrowseContext(): GeoBrowseContextValue {
  const ctx = useContext(GeoBrowseContext);
  if (!ctx) {
    throw new Error('useGeoBrowseContext must be used within GeoBrowseProvider');
  }
  return ctx;
}
